var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isDismissed)?_c('gl-alert',_vm._g(_vm._b({on:{"dismiss":_vm.dismiss}},'gl-alert',_vm.$attrs,false),_vm.$listeners),[_c('div',{directives:[{name:"safe-html",rawName:"v-safe-html",value:(_vm.html),expression:"html"}]})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }